// --- components/MapConfirmModal.jsx ---
import React, { useMemo, useState } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { reverseGeocodeFR } from "../services/geocode";
import { parseAddressComponents, normalizeCity } from "../services/adress";

const containerStyle = { width: "100%", height: 380 };
const defaultCenter = { lat: 46.603354, lng: 1.888334 };

export default function MapConfirmModal({ open, onClose, candidate, onConfirm }) {
  const { isLoaded } = useLoadScript({ googleMapsApiKey: "…", language: "fr", region: "FR" });
  const start = useMemo(() => ({
    lat: candidate?.geometry?.location?.lat || candidate?.lat || defaultCenter.lat,
    lng: candidate?.geometry?.location?.lng || candidate?.lng || defaultCenter.lng,
  }), [candidate]);

  const [pos, setPos] = useState(start);
  const [displayAddr, setDisplayAddr] = useState(candidate?.formatted_address || "");

  if (!open) return null;

  const handleDragEnd = async (e) => {
    const lat = e.latLng.lat(), lng = e.latLng.lng();
    setPos({ lat, lng });
    try {
      const rev = await reverseGeocodeFR(lat, lng);
      setDisplayAddr(rev.formatted_address);
    } catch {}
  };

  const handleConfirm = () => {
    const comp = candidate?.address_components || [];
    const parsed = parseAddressComponents(comp);
    onConfirm({
      lat: pos.lat,
      lng: pos.lng,
      formattedAddress: displayAddr || candidate?.formatted_address || "",
      place_id: candidate?.place_id || "",
      address1: parsed.address1 || "",
      postalCode: parsed.postalCode || "",
      city: normalizeCity(parsed.city || ""),
      country: parsed.country || "France",
    });
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl p-5">
        <h3 className="text-xl font-semibold mb-3">Vérifier l’adresse sur la carte</h3>
        <p className="text-sm mb-3">{displayAddr}</p>
        <div className="rounded-lg overflow-hidden border">
          {isLoaded && (
            <GoogleMap mapContainerStyle={containerStyle} center={pos} zoom={17}>
              <Marker position={pos} draggable onDragEnd={handleDragEnd} />
            </GoogleMap>
          )}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="px-4 py-2 rounded border">Annuler</button>
          <button onClick={handleConfirm} className="px-4 py-2 rounded bg-blue-600 text-white">
            Confirmer cette position
          </button>
        </div>
      </div>
    </div>
  );
}
